export var DateFormat;
(function (DateFormat) {
    function fromLocale(locale) {
        let result;
        switch (locale) {
            case "sq-AL":
            case "es-AR":
            case "it-IT":
            case "en-GB":
            case "fr-FR":
                result = "dd/mm/YYYY";
                break;
            case "en-US":
                result = "mm/dd/YYYY";
                break;
            case "et-EE":
            case "de-AT":
            case "de-DE":
            case "he-IL":
            case "is-IS":
            case "lv-LV":
            case "pl-PL":
            case "ru-RU":
            case "fi-FI":
                result = "dd.mm.YYYY";
                break;
            case "hi-IN":
            case "en-IN":
                result = "dd-mm-YYYY";
                break;
            default:
                result = "YYYY-mm-dd";
                break;
        }
        return result;
    }
    DateFormat.fromLocale = fromLocale;
    function toLocale(format) {
        let result;
        switch (format) {
            case "dd/mm/YYYY":
                result = "en-GB";
                break;
            case "mm/dd/YYYY":
                result = "en-US";
                break;
            case "dd.mm.YYYY":
                result = "de-DE";
                break;
            default:
                result = "sv-SE";
                break;
        }
        return result;
    }
    DateFormat.toLocale = toLocale;
    function is(value) {
        return (typeof value == "string" &&
            (value == "YYYY-mm-dd" || value == "dd/mm/YYYY" || value == "dd.mm.YYYY" || value == "mm/dd/YYYY"));
    }
    DateFormat.is = is;
})(DateFormat || (DateFormat = {}));
//# sourceMappingURL=DateFormat.js.map